import createIconComponent from './utils/createIconComponent';
import React from 'react';
const AlertLargeSuccess = createIconComponent({
  height: 32,
  width: 29,
  content: (
    <g>
      <path d='M14 0L28 8L28 24L14 32L0 24V8L14 0Z' fill='' />
      <path d='M14 0L28 8L28 24L14 32L0 24V8L14 0Z' fill='' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19.9636 10.8935C20.5355 11.3895 20.5957 12.2557 20.0979 12.8261L13.3735 20.5308C12.8919 21.0826 12.0597 21.1581 11.4862 20.7019L8.07308 17.9872C7.48095 17.5163 7.38398 16.6539 7.85671 16.0632V16.0632C8.32745 15.475 9.18534 15.3785 9.77495 15.8475L12.1685 17.7513L18.0369 11.0274C18.5325 10.4595 19.3942 10.3996 19.9636 10.8935V10.8935Z'
        fill='white'
      />
    </g>
  ),
});
AlertLargeSuccess.displayName = 'AlertLargeSuccess';
export default AlertLargeSuccess;
